import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {cordovaAppInitializer} from 'app-cli';
import * as Sentry from "@sentry/angular";
import {NavbarModule} from './navbar/navbar.module';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {PrimaryModule} from './primary/primary.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NavbarModule,
    FontAwesomeModule,
    PrimaryModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [{
    provide: APP_INITIALIZER,
    useFactory: cordovaAppInitializer,
    multi: true,
  }, {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      showDialog: false,
    }),
  },],
  bootstrap: [AppComponent],
})
export class AppModule {
}
